import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    dialogContentExpansionPanel: {
      padding: 0,
    },
    dialogContentSimpleList: {
      padding: theme.spacing(0, 1, 1, 1),
    },
    expansionPanelSummaryRoot: {
      paddingLeft: theme.spacing(),
    },
    expansionPanelSummaryContent: {
      overflow: 'hidden',
    },
    expansionPanelDetailsRoot: {
      paddingTop: 0,
      paddingLeft: theme.spacing(3),
    },
  };
};
